import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { CdnClientUrl } from '@deltek/specification-client/core/Utilities/urlUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/Add'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    emptyStateContainer: {
        height: `calc(100vh - 100px)`,
    },
    bigHeading: {
        color: '#02A09C',
        fontSize: pxToRem(64),
    },
    thinText: {
        fontWeight: 300,
    },
    paddedText: {
        backgroundColor: '#02A09C',
        borderRadius: 4,
        color: theme.palette.secondary.main,
        padding: theme.spacing(1),
    },
    paddedTextWithWhiteBG: {
        borderRadius: 4,
        color: '#626262',
        padding: theme.spacing(1),
    },
    whiteFont: {
        color: theme.palette.common.white,
    },
    centerButtonWithText: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: theme.spacing(3),
    },
}))

export interface ProjectsPageEmptyStateProps {
    variant?: 'readOnly' | 'full'
    onAddClick?: () => void
}

const ProjectsPageEmptyState: React.FC<ProjectsPageEmptyStateProps> = ({
    variant = 'full',
    onAddClick,
}) => {
    const classes = useStyles()

    const handleAddProjectButtonClick = () => {
        if (onAddClick) onAddClick()
    }
    return (
        <GridContainer
            direction="column"
            justifyContent="center"
            alignItems="center"
            className={classes.emptyStateContainer}
        >
            <GridItem>
                <Typography
                    className={clsx(classes.bigHeading, classes.thinText)}
                    variant="h1"
                >
                    {variant === 'full' ? 'Get Started!' : 'Whoa! Hold On.'}
                </Typography>
            </GridItem>
            <GridItem>
                <img
                    src={`${CdnClientUrl}/empty_project.png`}
                    alt="Get Started!"
                    useMap={variant === 'full' ? '#emptyProjectMap' : ''}
                />
                {variant === 'full' && (
                    <map name="emptyProjectMap">
                        <area
                            alt="Get started image button"
                            onClick={handleAddProjectButtonClick}
                            coords="178,196,28"
                            shape="circle"
                            style={{ cursor: 'pointer' }}
                        />
                    </map>
                )}
            </GridItem>
            <GridItem>
                {variant === 'full' ? (
                    <>
                        <div className={classes.centerButtonWithText}>
                            <RoundButton
                                backgroundColor="#3AD29F"
                                borderColor="#10BE84"
                                onClick={handleAddProjectButtonClick}
                                hasShadow
                                size="large"
                                startIcon={<AddIcon fontSize="large" />}
                            >
                                Add A Project
                            </RoundButton>
                        </div>
                        <div className={classes.centerButtonWithText}>
                            <Typography
                                variant="h6"
                                className={classes.paddedTextWithWhiteBG}
                            >
                                Or, ask a Team member to add you to their
                                existing project.
                            </Typography>
                        </div>
                    </>
                ) : (
                    <div className={classes.paddedText}>
                        <Typography variant="h5" className={classes.whiteFont}>
                            Please ask an Administrator or Author to add you to
                            an existing project.
                        </Typography>
                    </div>
                )}
            </GridItem>
        </GridContainer>
    )
}

export default ProjectsPageEmptyState
